// All this needs to be refactor once we have the correct designs
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { navigationService } from 'src/config/rootService';
import { SOURCE_TYPES } from 'src/modules/user/models/user';

import takeover from 'src/public/img/takeover.svg';
import { CrisisModal } from 'src/shared/components/CrisisModal';
import { Button, pxToRem } from '@modernhealth/vital-components';
import { color, font } from 'src/shared/styles/variables';
import { TakeoverLayout } from 'src/shared/layout/TakeoverLayout';

const HeadingText = styled.h3(
    {
        color: color.pickledBluewood,
    },
    font.heavy(font.size.extraLarge),
);

const DescriptionText = styled.p(
    {
        color: color.blueBayoux,
        width: pxToRem(412),
    },
    font.medium(font.size.mediumExtended),
);

const Container = styled.div({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
});

const ContentContainer = styled.div({
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

const ButtonsContainer = styled.div({
    width: pxToRem(400),
    textAlign: 'center',
    alignItems: 'center',
    marginTop: pxToRem(36),
    '& > *': {
        marginBottom: pxToRem(16),
    },
});

export enum Phq9TakeoverModalTestID {
    ExploreButton = 'Phq9TakeoverModalTestID.ExploreButton',
    MatchButton = 'Phq9TakeoverModalTestID.MatchButton',
    ContinueButton = 'Phq9TakeoverModalTestID.ContinueButton',
}

export const Phq9TakeoverPage: React.FC = () => {
    const { t } = useTranslation();
    const [showCrisisModal, setShowCrisisModal] = useState(false);

    return (
        <TakeoverLayout>
            <Container>
                <ContentContainer>
                    <img src={takeover} alt="girls with smartphone and laptop" />
                    <HeadingText>{t('dashboard:takeover_screen.title')}</HeadingText>
                    <DescriptionText>{t('dashboard:takeover_screen.description')}</DescriptionText>
                    <ButtonsContainer>
                        <Button
                            variant="secondary"
                            size="large"
                            fluid
                            onClick={() => setShowCrisisModal(true)}
                            data-testid={Phq9TakeoverModalTestID.ExploreButton}
                        >
                            {t('dashboard:takeover_screen.button.explore')}
                        </Button>
                        <Button
                            size="large"
                            fluid
                            onClick={() => navigationService.navigate('/work-with-a-therapist')}
                            data-testid={Phq9TakeoverModalTestID.MatchButton}
                        >
                            {t('dashboard:takeover_screen.button.match')}
                        </Button>
                        <Button
                            variant="flat"
                            size="large"
                            fluid
                            onClick={() => navigationService.navigate('/dashboard')}
                            data-testid={Phq9TakeoverModalTestID.ContinueButton}
                        >
                            {t('dashboard:takeover_screen.button.continue')}
                        </Button>
                    </ButtonsContainer>
                </ContentContainer>
            </Container>
            <CrisisModal
                visible={showCrisisModal}
                onClose={() => {
                    setShowCrisisModal(false);
                }}
                source={SOURCE_TYPES.TAKEOVER_SCREEN}
            />
        </TakeoverLayout>
    );
};
